import GlobalAxios from "../axios/axios-config";
import TemporaryAxios from "../axios/temprary-axios-config";
import { ILaboratorialExamsResultLabPdfResponse } from "../components/Exams/ExamsResultLabPdf/models";
import { IGetLaboratorialExamsFileParams } from "../models/laboratorial-exams";

const BASE_URL =
  process.env.REACT_APP_APP + "/api/v1/LaboratorialExams/file/base64";
const RESULT_LAB_PDF_URL =
  process.env.REACT_APP_APP + "/api/v1/LaboratorialExams";

export const getLaboratorialExamsFile = ({
  Identifier,
  ImageIdentifier,
}: IGetLaboratorialExamsFileParams) => {
  const params = { Identifier, ImageIdentifier };
  return GlobalAxios.get<string>(BASE_URL, { params });
};

export const getLaboratorialExamsFileAsTemporary = ({
  Identifier,
  ImageIdentifier,
}: Omit<IGetLaboratorialExamsFileParams, "isTemporary">) => {
  const params = { Identifier, ImageIdentifier };

  return TemporaryAxios.get<string>(`${BASE_URL}/Tasy/`, { params });
};

export const getLaboratorialExamsResultLabPdf = (Id: number) => {
  return GlobalAxios.get<ArrayBuffer>(`${RESULT_LAB_PDF_URL}/ResultLabPdf/${Id}`,
    { responseType: "arraybuffer" },);
};
export const getLaboratorialExamsResultLabPdfList = (ResultLabId: number) => {
  return GlobalAxios.get<ILaboratorialExamsResultLabPdfResponse[]>(`${RESULT_LAB_PDF_URL}/ResultLabPdfList/${ResultLabId}`);
};


export const getLaboratorialExamsResultLabPdfAsTemporary = (Id: number) => {
  return TemporaryAxios.get<ArrayBuffer>(`${RESULT_LAB_PDF_URL}/Tasy/ResultLabPdf/${Id}`,
    { responseType: "arraybuffer" },);
};
export const getLaboratorialExamsResultLabPdfListAsTemporary =  (ResultLabId: number) => {
  return TemporaryAxios.get<ILaboratorialExamsResultLabPdfResponse[]>(`${RESULT_LAB_PDF_URL}/Tasy/ResultLabPdfList/${ResultLabId}`);
};
